import axios from "../http";
import type { BaseReply } from "../type";
import type { userloginType, UserBaseInfoType } from "../../types";

// 获取手机登录验证码
export function getVerifyCode(data: {
  phone: string;
  'tencent_captcha.ticket': string;
  'tencent_captcha.rand_str': string;
  code_type: 1;
}) {
  return axios({
    method: 'get',
    url: '/user/v1/login/verify/code',
    params: data
  });
}

// 校验手机验证码
export function checkVerifyCode(data: { phone: string; code: string; mark: number }) {
  return axios({
    method: "post",
    url: "/user/v1/verify/code",
    data
  });
}

// 手机号登录注册
export function loginByVerify(data: userloginType) {
  return axios<BaseReply<UserBaseInfoType>>({
    method: "post",
    url: "/user/v1/login/verify/mobile",
    data
  });
}

/**查找账号信息,不需要token,最好先通过验证码校验:checkVerifyCode()
 * @field access_token:小程序授权的token,非小程序授权时不需要,type 1时必选
 */
export function getAccount(data: { phone: string; access_token?: string; type?: number }) {
  return axios<BaseReply<UserBaseInfoType>>({
    method: "post",
    url: "/user/v1/account",
    data
  });
}

/* 获取用户信息V2 */
export function getUserInfo() {
	return axios<BaseReply<UserBaseInfoType>>({
		method: 'get',
		url: '/user/v2/base_info'
	});
}